import {sortBy, createSelector, includes, groupBy} from 'helpers';
import {today, id} from 'store/common';
import {categories} from './categories';

const blacklist = state => state.settings.today.notesCategoriesBlacklist;

const byDate = createSelector(
  state => state.notes.index,
  state => groupBy(state, note => note.morning && ''.concat(note.date, note.category || note.categoryId)),
);

const sortedCategories = createSelector(
  categories,
  categories => sortBy(categories, ({ id }) => id == 'note'),
);

export const morningThoughtsCategories = createSelector(
  [ blacklist, sortedCategories ],
  ( blacklist, sortedCategories ) => ({
    all: sortedCategories,
    visible: sortedCategories.filter(category => !includes(blacklist, category.id)),
  })
);

export const morningThoughtsNotes = createSelector(
  [ byDate, today, id ],
  ( byDate, today, id ) => byDate[today.unix() + '' + id],
);
